import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import Dashboard from "@/pages/Dashboard";
import Training from "@/pages/Training";
import Downloads from "@/pages/Downloads";
import Pricing from "@/pages/Pricing";
import Inventory from "@/pages/Inventory";
import { SupportList, SupportDetail } from "@/pages/Support";
import Account from "@/pages/Account";
import Billing from "@/pages/Billing";
import { BillingSuccess, BillingCancel } from "@/pages/BillingResult";
import Admin from "@/pages/Admin";
import { Terms, Privacy, Refund } from "@/pages/Legal";

import "@/App.css";

const TOAST_OPTIONS = {
  style: {
    background: "#0A0A0A",
    border: "1px solid #262626",
    color: "#fff",
    borderRadius: "2px",
    fontFamily: "IBM Plex Sans, sans-serif",
  },
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" theme="dark" toastOptions={TOAST_OPTIONS} />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Public-or-member pages (different content based on auth) */}
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/inventory" element={<Inventory />} />

          {/* Authenticated */}
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
          <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
          <Route path="/billing/success" element={<ProtectedRoute><BillingSuccess /></ProtectedRoute>} />
          <Route path="/billing/cancel" element={<ProtectedRoute><BillingCancel /></ProtectedRoute>} />

          {/* Member-only */}
          <Route path="/training" element={<ProtectedRoute><Training /></ProtectedRoute>} />
          <Route path="/downloads" element={<ProtectedRoute><Downloads /></ProtectedRoute>} />
          <Route path="/support" element={<ProtectedRoute><SupportList /></ProtectedRoute>} />
          <Route path="/support/:id" element={<ProtectedRoute><SupportDetail /></ProtectedRoute>} />

          {/* Admin */}
          <Route path="/admin" element={<ProtectedRoute requireAdmin><Admin /></ProtectedRoute>} />

          {/* Legal */}
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/refund-policy" element={<Refund />} />

          <Route path="*" element={<Landing />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
